import React from 'react';

const BackgroundView = props => {
  const backgroundStyle = {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    position: 'fixed',
    width: '100%',
    height: '100%',
    zIndex: 0,
  };

  return <div style={backgroundStyle} />;
};

BackgroundView.defaultProps = {
  width: 0,
  height: 0,
};

export default BackgroundView;
